import styleInject from 'style-inject';

var css_248z = ".InfoBox-module_container__MO0aI{background-color:var(--color-notice200);border:1px solid var(--color-notice);border-radius:var(--size--4);padding:var(--space-2xs-xs)}.InfoBox-module_icon__vt9XP{color:var(--color-notice)}.InfoBox-module_message__bKl41{color:var(--color-text)}";
var styles = {"container":"InfoBox-module_container__MO0aI","icon":"InfoBox-module_icon__vt9XP","message":"InfoBox-module_message__bKl41"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5mb0JveC5tb2R1bGUuc2Nzcy5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OyJ9
